var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogOut = function SvgLogOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#212121",
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeWidth: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 1h6a1 1 0 1 1 0 2H4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h6a1 1 0 1 1 0 2H4a3 3 0 0 1-3-3V4a3 3 0 0 1 3-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.293 14.293a1 1 0 1 0 1.414 1.414l4-4a1 1 0 0 0 0-1.414l-4-4a1 1 0 1 0-1.414 1.414L13.586 10H6a1 1 0 1 0 0 2h7.586l-2.293 2.293Z"
  }))));
};
export default SvgLogOut;